import { modelOptions, prop } from '@typegoose/typegoose';
import * as mongoose from 'mongoose';

@modelOptions({ schemaOptions: { collection: 'policyRules' }, options: { customName: 'policyRules' } })
export class PolicyRulesModel {
  @prop({ required: true, _id: true })
  _id: mongoose.Types.ObjectId;
}
